module.exports = __webpack_public_path__ + "img/icon_default_img.00eeb9d2.svg";